<template>
  <div class="mine-page">
    <!-- Header -->
    <header class="mine-header">
      <div class="mine-header__user">
        <div class="mine-header__avatar" @click="$jumpTo('/editProfile')">
          <img
            v-if="InitDate.headUrl != null"
            :src="require(`@/assets/img/avatar/avatar_${InitDate.headUrl}.jpg`)"
            class="mine-header__avatar-img"
          />
          <div v-else class="mine-header__avatar-placeholder"></div>
        </div>
        <div class="mine-header__info">
          <div class="mine-header__name">{{ InitDate.account || '--' }}</div>
          <div class="mine-header__id" @click="copyText">
            <span>ID: {{ InitDate.inviteCode }}</span>
            <img src="../../assets/img/drawer/copy-ttt.png" width="12" />
          </div>
        </div>
      </div>
      <div class="mine-header__right">
        <div v-if="InitDate.vipLevel != null" class="mine-header__vip" @click="$jumpTo('/vipLevels')">
          <img :src="require(`@/assets/img/vip/V${InitDate.vipLevel || 0}.png`)" width="80" />
        </div>
        <button class="mine-header__settings" @click="$jumpTo('/settings')">
          <van-icon name="setting-o" size="22" color="#94a3b8" />
        </button>
      </div>
    </header>

    <!-- Balance Card -->
    <section class="mine-balance">
      <div class="mine-balance__header">
        <span class="mine-balance__label">{{ $lang.common_txt259 || 'Account Balance' }}</span>
        <span class="mine-balance__amount">
          {{ getCurrency }}{{ $formatNumberWithCommas(InitDate2.totalBalance || InitDate2.balance || 0) }}
        </span>
      </div>

      <div class="mine-balance__stats">
        <div class="mine-balance__stat">
          <span class="mine-balance__stat-label">{{ $lang.mine_main || 'Main' }}</span>
          <span class="mine-balance__stat-value">{{ getCurrency }}{{ $formatNumberWithCommas(InitDate2.balance || 0) }}</span>
        </div>
        <div class="mine-balance__stat mine-balance__stat--green">
          <span class="mine-balance__stat-label">{{ $lang.mine_bonus || 'Bonus' }}</span>
          <span class="mine-balance__stat-value">{{ getCurrency }}{{ $formatNumberWithCommas(InitDate2.promoBalance || 0) }}</span>
        </div>
        <div class="mine-balance__stat mine-balance__stat--green">
          <span class="mine-balance__stat-label">{{ $lang.mine_cashback || 'Cashback' }}</span>
          <span class="mine-balance__stat-value">{{ getCurrency }}{{ $formatNumberWithCommas(InitDate2.cashback || 0) }}</span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="mine-balance__actions">
        <button class="mine-btn mine-btn--deposit" @click="goToDesposit(0)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 00-2 2v8a2 2 0 002 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
          <span>{{ $lang.Depósito || 'Deposit' }}</span>
        </button>
        <button class="mine-btn mine-btn--withdraw" @click="goToDesposit(1)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.94s4.18 1.36 4.18 3.87c-.01 1.88-1.44 2.96-3.12 3.17z"/></svg>
          <span>{{ $lang.Saque || 'Withdraw' }}</span>
        </button>
      </div>
    </section>

    <!-- History Links -->
    <section class="mine-history">
      <div class="mine-history__item" @click="$jumpTo('/myCollection')">
        <img src="../../assets/img/otgame/cebianlan_15.png" width="20" class="mine-history__icon" style="border-radius: 0;" />
        <span>{{ $lang.common_txt281 || 'Favorites' }}</span>
        <van-icon name="arrow" size="14" color="#4b5563" />
      </div>
      <div class="mine-history__item" @click="$jumpTo('/transactionRecords')">
        <svg class="mine-history__icon" viewBox="0 0 24 24" fill="#24ee89"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2zm0-4H7V7h10v2z"/></svg>
        <span>{{ $lang.txRecords_title || 'Transaction Records' }}</span>
        <van-icon name="arrow" size="14" color="#4b5563" />
      </div>
      <div class="mine-history__item" @click="$jumpTo('/billGame')">
        <svg class="mine-history__icon" viewBox="0 0 24 24" fill="#24ee89"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>
        <span>{{ $lang.common_txt261 || 'Game Records' }}</span>
        <van-icon name="arrow" size="14" color="#4b5563" />
      </div>
    </section>

    <!-- Account Management -->
    <section class="mine-menu">
      <div class="mine-menu__group">
        <!-- Set Password -->
        <div class="mine-menu__item" @click="$jumpTo('/passwordLogin')">
          <div class="mine-menu__left">
            <svg class="mine-menu__icon" viewBox="0 0 24 24" fill="#94a3b8"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
            <span>{{ $lang.mine_txt9 || 'Change Login Password' }}</span>
          </div>
          <van-icon name="arrow" size="14" color="#4b5563" />
        </div>
        <!-- Withdrawal Account -->
        <div class="mine-menu__item" @click="goToBank">
          <div class="mine-menu__left">
            <svg class="mine-menu__icon" viewBox="0 0 24 24" fill="#94a3b8"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>
            <span>{{ $lang.bank_title || 'Bank Card' }}</span>
          </div>
          <van-icon name="arrow" size="14" color="#4b5563" />
        </div>
        <!-- Withdrawal Password -->
        <div class="mine-menu__item" @click="$jumpTo('/setPassWord')">
          <div class="mine-menu__left">
            <svg class="mine-menu__icon" viewBox="0 0 24 24" fill="#94a3b8"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>
            <span>{{ $lang.mine_txt10 || 'Change Withdrawal Password' }}</span>
          </div>
          <van-icon name="arrow" size="14" color="#4b5563" />
        </div>
        <!-- Settings -->
        <div class="mine-menu__item" @click="$jumpTo('/settings')">
          <div class="mine-menu__left">
            <svg class="mine-menu__icon" viewBox="0 0 24 24" fill="#94a3b8"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.488.488 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6A3.6 3.6 0 1115.6 12 3.611 3.611 0 0112 15.6z"/></svg>
            <span>{{ $lang.settings_title || 'Settings' }}</span>
          </div>
          <van-icon name="arrow" size="14" color="#4b5563" />
        </div>
        <!-- Customer Service -->
        <div class="mine-menu__item" @click="$jumpTo('/Support')">
          <div class="mine-menu__left">
            <svg class="mine-menu__icon" viewBox="0 0 24 24" fill="#94a3b8"><path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"/></svg>
            <span>{{ $lang.common_txt291 || 'Customer Service' }}</span>
          </div>
          <van-icon name="arrow" size="14" color="#4b5563" />
        </div>
      </div>
    </section>

    <!-- Logout -->
    <div class="mine-logout">
      <button class="mine-logout__btn" @click="showLogoutPopup = true">
        {{ $lang.mine_txt14 || 'Log Out' }}
      </button>
    </div>

    <!-- Logout Popup -->
    <van-popup v-model="showLogoutPopup" round :close-on-click-overlay="true" class="logout-popup">
      <div class="logout-popup__content">
        <p class="logout-popup__title">{{ $lang.mine_txt4 }}</p>
        <div class="logout-popup__actions">
          <button class="logout-popup__btn logout-popup__btn--cancel" @click="showLogoutPopup = false">
            {{ $lang.Cancelar }}
          </button>
          <button class="logout-popup__btn logout-popup__btn--confirm" @click="confirmLogout">
            {{ $lang.Confirmar }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Init, GameBalanceList, Logout } from '@/api/common'

export default {
  name: 'mine',
  data() {
    return {
      showLogoutPopup: false,
      InitDate: {
        inviteCode: '',
        headUrl: null,
        account: '',
        vipLevel: null,
        privacyPasswdSetted: 'no',
        realName: ''
      },
      InitDate2: {
        balance: 0,
        bonus: 0,
        cashback: 0,
        totalBalance: 0
      }
    }
  },
  mounted() {
    this.Init()
    this.GetGameBalanceList()
  },
  methods: {
    async Init() {
      try {
        const data = await Init()
        if (data.status === 'ok') {
          this.InitDate = data.content
        }
      } catch (e) {
        console.error('Init error', e)
      }
    },
    async GetGameBalanceList() {
      try {
        const data = await GameBalanceList()
        if (data.status === 'ok') {
          this.InitDate2 = data.content
        }
      } catch (e) {
        console.error('GetGameBalanceList error', e)
      }
    },
    goToDesposit(i) {
      if (i === 0) {
        this.$jumpTo('/rechargeCont')
      } else {
        if (this.InitDate.privacyPasswdSetted === 'no') {
          this.$jumpTo('/setPassWord')
        } else {
          this.$jumpTo('/bankAdd')
        }
      }
    },
    goToBank() {
      if (this.InitDate.realName) {
        this.$jumpTo('/bank')
      } else {
        this.$jumpTo('/authName')
      }
    },
    copyText() {
      const text = this.InitDate.inviteCode || ''
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$toast({ message: this.$lang.Sucesso, icon: 'success' })
    },
    async confirmLogout() {
      try {
        const data = await Logout()
        if (data.status === 'ok') {
          this.showLogoutPopup = false
          localStorage.removeItem('token')
          this.$jumpTo('/home', {}, { replace: true })
          setTimeout(() => { window.location.reload() }, 200)
        } else {
          this.$toast({ message: data.msg, icon: 'cross' })
        }
      } catch (e) {
        console.error('Logout error', e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@bg: #1a1d29;
@card: #252936;
@neon: #24ee89;
@yellow: #f8f510;
@muted: #94a3b8;
@border: rgba(255, 255, 255, 0.06);

.mine-page {
  min-height: 100vh;
  background: @bg;
  padding-bottom: 100px;
}

// ====== HEADER ======
.mine-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 16px;

  &__user {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;

    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &-placeholder {
      width: 100%;
      height: 100%;
      background: @card;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__name {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
  }

  &__id {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: @muted;
    cursor: pointer;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__vip {
    display: flex;
    align-items: center;
  }

  &__settings {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
  }
}

// ====== BALANCE ======
.mine-balance {
  margin: 0 16px 16px;
  background: @card;
  border-radius: 12px;
  padding: 20px 16px;
  border: 1px solid @border;

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
  }

  &__label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #6b7280;
    margin-bottom: 6px;
  }

  &__amount {
    font-size: 34px;
    font-weight: 900;
    color: @yellow;
    text-shadow: 0 0 20px rgba(248, 245, 16, 0.15);
  }

  &__stats {
    display: flex;
    justify-content: space-around;
    background: rgba(255, 255, 255, 0.04);
    border-radius: 8px;
    padding: 12px 8px;
    margin-bottom: 16px;
  }

  &__stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    &-label {
      font-size: 10px;
      color: #6b7280;
    }

    &-value {
      font-size: 13px;
      font-weight: 600;
      color: #ffffff;
    }

    &--green &-value {
      color: @neon;
    }
  }

  &__actions {
    display: flex;
    gap: 10px;
  }
}

.mine-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: none;
  cursor: pointer;
  transition: transform 0.1s;

  &:active {
    transform: scale(0.96);
  }

  &--deposit {
    background: linear-gradient(135deg, @neon 0%, #17b366 100%);
    color: #1a1d29;
    box-shadow: 0 4px 16px rgba(36, 238, 137, 0.3);
  }

  &--withdraw {
    background: linear-gradient(135deg, #2d313e 0%, #1a1d29 100%);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
}

// ====== HISTORY LINKS ======
.mine-history {
  margin: 0 16px 16px;
  background: @card;
  border-radius: 10px;
  overflow: hidden;

  &__icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    cursor: pointer;
    border-bottom: 1px solid @border;

    &:last-child {
      border-bottom: none;
    }

    span {
      flex: 1;
      font-size: 14px;
      color: #ffffff;
    }
  }
}

// ====== MENU ======
.mine-menu {
  padding: 0 16px;
  margin-bottom: 16px;

  &__group {
    background: @card;
    border-radius: 10px;
    overflow: hidden;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    border-bottom: 1px solid @border;

    &:last-child {
      border-bottom: none;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;

    span {
      font-size: 14px;
      color: #ffffff;
    }
  }

  &__icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__badge {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 2px 8px;
    border-radius: 4px;

    &--red {
      background: rgba(239, 68, 68, 0.15);
      color: #ef4444;
    }
  }
}

// ====== DISABLED ======
.disabled-feature {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}

// ====== LOGOUT ======
.mine-logout {
  padding: 0 16px;

  &__btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(220, 38, 38, 0.1);
    border: 1px solid rgba(220, 38, 38, 0.3);
    border-radius: 10px;
    padding: 14px;
    font-size: 14px;
    font-weight: 700;
    color: #dc2626;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: transform 0.1s;

    &:active {
      transform: scale(0.98);
    }
  }
}

// ====== LOGOUT POPUP ======
.logout-popup {
  width: 300px;
  background: @card !important;
  border-radius: 16px !important;

  &__content {
    padding: 24px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    line-height: 1.4;
  }

  &__actions {
    display: flex;
    gap: 10px;
    width: 100%;
  }

  &__btn {
    flex: 1;
    min-width: 0;
    height: 42px;
    padding: 0 6px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &--cancel {
      background: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }

    &--confirm {
      background: #ef4444;
      color: #ffffff;
    }

    &:active {
      opacity: 0.85;
    }
  }
}

@media (min-width: 769px) {
  .mine-page {
    max-width: 450px;
    margin: 0 auto;
  }
}
</style>
